import HttpClient from './HttpClient.js'

const http = () => HttpClient()

class RarityService {
  static async getAllRarities() {
    try {
      const response = await http().get('/rarities')
      return response.data
    } catch (error) {
      console.error('Error al obtener rarezas:', error)
      throw error
    }
  }

  static async getRaritiesMap() {
    try {
      const response = await http().get('/rarities/map')
      return response.data
    } catch (error) {
      console.error('Error al obtener mapa de rarezas:', error)
      throw error
    }
  }

  static async getRarityById(id) {
    try {
      const response = await http().get(`/rarities/${id}`)
      return response.data
    } catch (error) {
      console.error('Error al obtener rareza por ID:', error)
      throw error
    }
  }

  static async getRarityByName(name) {
    try {
      const response = await http().get(`/rarities/name/${name}`)
      return response.data
    } catch (error) {
      console.error('Error al obtener rareza por nombre:', error)
      throw error
    }
  }

  static async createRarity(rarityData) {
    try {
      const response = await http().post('/rarities', rarityData)
      return response.data
    } catch (error) {
      console.error('Error al crear rareza:', error)
      throw error
    }
  }

  static async updateRarity(id, rarityData) {
    try {
      const response = await http().put(`/rarities/${id}`, rarityData)
      return response.data
    } catch (error) {
      console.error('Error al actualizar rareza:', error)
      throw error
    }
  }

  static async deleteRarity(id) {
    try {
      const response = await http().delete(`/rarities/${id}`)
      return response.data
    } catch (error) {
      console.error('Error al eliminar rareza:', error)
      throw error
    }
  }
}

export default RarityService
